









import { Component, Mixins, Prop } from "vue-property-decorator";
import { DateInputMethodOptionKinds } from "../../../../domain/document/inputMethodOptionKinds";
import { DisableableMixin } from "../../../system/mixins";
import DateObject from "../objects/DateObject.vue";
import DateInputMethodEditor from "../inputMethodEditors/DateInputMethodEditor.vue";

@Component({
  components: {
    DateInputMethodEditor,
  }
})
export default class DateBehaviorEditor extends Mixins(DisableableMixin) {
  @Prop()
  source: DateObject;

  get isVisible(): boolean {
    return this.source.inputMethodOptionKind !== DateInputMethodOptionKinds.HisItem;
  }
}
